import { i18n } from "../plugin/vue-i18n";
import { getBumpSettings } from "./productHelper";

const { t } = i18n.global;

export const defaultShadow = {
  horizontal: 0,
  vertical: 0,
  blur: 0,
  spread: 0,
  color: "FFFFFF",
};

export const defaultPadding = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
};

export const defaultGreenColor = "18BD5BFF";
export const defaultBlueColor = "155EEFFF";

export const defaultBtnPadding = { top: 9, bottom: 9, left: 10, right: 10 };

export const defaultBorder = {
  border: 0,
  radius: 0,
  color: "FFFFFF",
  type: "none",
};

export const defaultTextStyle = {
  fontFamily: "Roboto",
  color: "000000",
  weight: 400,
  bgColor: "FFFFFF",
  border: defaultBorder,
  shadow: defaultShadow,
  padding: defaultPadding,
};
export const getTextBgColor = (bgColor: any, color: any, formBg: any) => {
  if (bgColor) {
    return bgColor;
  } else if (color === "FFFFFF") {
    return formBg;
  }
  return "FFFFFF";
};

export const getBorderBasedOnCurrentSetup = (border, bgColor = "FFFFFF") => {
  const { border: borderSize, type: borderType, color: borderColor } = border;
  return {
    borderSize: borderSize == 0 ? 1 : borderSize,
    borderType: borderType === "none" ? "solid" : borderType,
    borderColor: bgColor === "FFFFFF" && borderColor === "FFFFFF" ? "000000" : borderColor,
  };
};

export const getBorder = (DBborder) => {
  const { color, radius, type, border } = defaultBorder;
  return {
    border: DBborder?.border || border,
    color: DBborder?.color || color,
    radius: DBborder?.radius || radius,
    type: DBborder?.type || type,
  };
};

export const defaultShortLabel = {
  color: "464d5f",
  fontFamily: "Roboto",
  fontSize: 12,
  fontWeight: 300,
};

export const getCheckBoxStyles = (fieldStyle: any) => {
  return `#_builder-form input[type=checkbox] {
    accent-color: #${fieldStyle.primaryColor};
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 4px !important;
    height: 16px !important;
    width: 16px !important;
    background: #ffffff;
    position: relative; 
    border: 1px solid #${fieldStyle.border.color};
      &:checked { 
      background : #${fieldStyle.primaryColor};

      &::after {
      content: '';
      position: absolute;
      left: 4px;
      top: 1px;
      width: 6px;
      height: 10px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
    }
  }`;
};

export const createFieldCSS = (fieldStyle: any, inputStyleType = "box", isMobile = false) => {
  const isLineEnabled = inputStyleType === "line" ? true : false;

  const getMobileOrDesktop = (mobileVal, desktopVal) =>
    isMobile ? mobileVal || desktopVal : desktopVal;

  const labelColor = getMobileOrDesktop(fieldStyle.mobileLabelColor, fieldStyle.labelColor);
  const labelFontSize = getMobileOrDesktop(
    fieldStyle.mobileLabelFontSize,
    fieldStyle.labelFontSize
  );
  const labelFontWeight = getMobileOrDesktop(
    fieldStyle.mobileLabelFontWeight,
    fieldStyle.labelFontWeight
  );
  const labelFontFamily = getMobileOrDesktop(
    fieldStyle.mobileLabelFontFamily,
    fieldStyle.labelFontFamily
  );

  const placeholderColor = getMobileOrDesktop(
    fieldStyle.mobilePlaceholderColor,
    fieldStyle.placeholderColor
  );
  const placeholderFontFamily = getMobileOrDesktop(
    fieldStyle.mobilePlaceholderFontFamily,
    fieldStyle.placeholderFontFamily
  );
  const placeholderFontSize = getMobileOrDesktop(
    fieldStyle.mobilePlaceholderFontSize,
    fieldStyle.placeholderFontSize
  );
  const placeholderFontWeight = getMobileOrDesktop(
    fieldStyle.mobilePlaceholderFontWeight,
    fieldStyle.placeholderFontWeight
  );

  const shortLabelColor = getMobileOrDesktop(
    fieldStyle.shortLabel?.mobileColor,
    fieldStyle.shortLabel?.color
  );
  const shortLabelFontFamily = getMobileOrDesktop(
    fieldStyle.shortLabel?.mobileFontFamily,
    fieldStyle.shortLabel?.fontFamily
  );
  const shortLabelFontSize = getMobileOrDesktop(
    fieldStyle.shortLabel?.mobileFontSize,
    fieldStyle.shortLabel?.fontSize
  );
  const shortLabelFontWeight = getMobileOrDesktop(
    fieldStyle.shortLabel?.mobileFontWeight,
    fieldStyle.shortLabel?.fontWeight
  );

  // Generate hover and focus styles if primaryColor is available
  const getHoverFocusStyles = () => {
    if (!fieldStyle?.primaryColor) {
      return "";
    }

    return `
  /* Input field hover and focus styles */
  #_builder-form .form-builder--item input[type=text][class=form-control]:hover,
  #_builder-form .form-builder--item .date-picker-custom-style:hover,
  #_builder-form .form-builder--item input[type=number]:hover,
  #_builder-form textarea:hover,
  #_builder-form input[type=tel]:hover,
  #_builder-form input[type=email]:hover,
  #_builder-form .multiselect .multiselect__tags:hover {
    ${isLineEnabled ? "border-bottom" : "border"}: ${fieldStyle.border.border}px ${
      fieldStyle.border.type
    } #${fieldStyle.primaryColor} !important;
  }

  /* Monetary element input group prepend hover styles */
  #_builder-form .input-group:hover .input-group-prepend .input-group-text {
    border-color: #${fieldStyle.primaryColor} !important;
    box-shadow: 0 0 0 2px #${fieldStyle.primaryColor}33 !important;
  }
  #_builder-form .form-builder--item input[type=text][class=form-control]:focus,
  #_builder-form .form-builder--item .date-picker-custom-style:focus,
  #_builder-form .form-builder--item input[type=number]:focus,
  #_builder-form textarea:focus,
  #_builder-form input[type=tel]:focus,
  #_builder-form input[type=email]:focus,
  #_builder-form .multiselect .multiselect__tags:focus {
    ${isLineEnabled ? "border-bottom" : "border"}: ${fieldStyle.border.border}px ${
      fieldStyle.border.type
    } #${fieldStyle.primaryColor} !important;
    outline: none;
  }

  /* Monetary element input group prepend focus styles */
  #_builder-form .input-group:focus-within .input-group-prepend .input-group-text {
    border-color: #${fieldStyle.primaryColor} !important;
    box-shadow: 0 0 0 2px #${fieldStyle.primaryColor}33 !important;
  }

  /* Checkbox and Radio button accent color */
   ${getCheckBoxStyles(fieldStyle)}
   /* Radio button styles */
   #_builder-form input[type=radio] {
    accent-color: #${fieldStyle.primaryColor};
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 50% !important;
    height: 16px !important;
    width: 16px !important;
    background: #ffffff;
    position: relative; 
    border: 1px solid #${fieldStyle.border.color};
    &:checked { 
      background : #FFFFFF;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background: #${fieldStyle.primaryColor};
      }
    }
  }

  /* Date picker cell hover effect with primary color */
  @media (hover: hover) {
    #_builder-form .vdpCell.selectable:hover .vdpCellContent {
      color: #fff !important;
      background: #${fieldStyle.primaryColor} !important;
    }
  }

  /* Date picker today cell with primary color */
  #_builder-form .vdpCell.today {
    color: #${fieldStyle.primaryColor} !important;
  }

  /* Date picker selected cell with primary color */
#_builder-form .vdpCell.selectable.selected .vdpCellContent {
  color: #fff !important;
  background: #${fieldStyle.primaryColor} !important;
}

  /* File upload hover styles */
  #_builder-form input[type=file]:hover,
  #_builder-form .custom-file-upload:hover,
  #_builder-form .file-input:hover {
    border-color: #${fieldStyle.primaryColor};
    box-shadow: 0 0 0 2px #${fieldStyle.primaryColor}33;
  }

  /* Signature field hover styles */
  #_builder-form .signature-button:hover {
    border-color: #${fieldStyle.primaryColor} !important;
    box-shadow: 0 0 0 2px #${fieldStyle.primaryColor}33;
  }

  /* Quantity container counter hover styles */
  #_builder-form .quantity-container-counter:hover {
    border-color: #${fieldStyle.primaryColor};
    box-shadow: 0 0 0 2px #${fieldStyle.primaryColor}33;
  }

  /* Bubble container hover styles */
  #_builder-form .bubble-container:hover,
  #_builder-form .bubble-checkbox-container:hover {
    border-color: #${fieldStyle.primaryColor} !important;
    box-shadow: 0 0 0 2px #${fieldStyle.primaryColor}33 !important;
  }

  /* Bubble checkbox checked state - apply primary color to container border */
  #_builder-form .bubble-container:has(input[type=checkbox]:checked),
  #_builder-form .bubble-checkbox-container:has(input[type=checkbox]:checked) {
    border-color: #${fieldStyle.primaryColor} !important;
    box-shadow: 0 0 0 2px #${fieldStyle.primaryColor}33 !important;
  }

  /* Bubble radio checked state when input is inside the label (common in preview) */
  #_builder-form .bubble-container:has(input[type=radio]:checked),
  #_builder-form .bubble-checkbox-container:has(input[type=radio]:checked) {
    border-color: #${fieldStyle.primaryColor} !important;
    box-shadow: 0 0 0 2px #${fieldStyle.primaryColor}33 !important;
  }

  /* Bubble radio checked state - apply primary color to label border and indicator */
  #_builder-form .option-radio-bubble input[type=radio]:checked + label {
    border-color: #${fieldStyle.primaryColor} !important;
  }
  #_builder-form .option-radio-bubble input[type=radio]:checked + label:before {
    border-color: #${fieldStyle.primaryColor} !important;
    background: #${fieldStyle.primaryColor} !important;
  }

  /* Payment suggestion tag container hover styles */
  #_builder-form .payment-suggestion-tag-container:hover {
    border-color: #${fieldStyle.primaryColor} !important;
    box-shadow: 0 0 0 2px #${fieldStyle.primaryColor}33 !important;
  }

  /* Payment suggestion tag container focus styles */
  #_builder-form .payment-suggestion-tag-container:focus-within {
    border-color: #${fieldStyle.primaryColor} !important;
    box-shadow: 0 0 0 2px #${fieldStyle.primaryColor}33 !important;
  }
  /* Dropdown hover and selection styles */
  #_builder-form .multiselect__option--highlight {
    background-color: #${fieldStyle.primaryColor};
    color: #000000;
  }
  #_builder-form .multiselect__option:hover {
    background-color: #${fieldStyle.primaryColor};
    color: #000000;
  }

  /* Multiselect tag styles */
  #_builder-form .multiselect__tag {
    border: 1px solid #${fieldStyle.primaryColor};
    color: #${fieldStyle.fontColor};
    background-color:transparent;
  }
  #_builder-form .multiselect__tag-icon {
    background-color:transparent;
    color: #98A2B3;
  }
  #_builder-form .multiselect__tag-icon:after {

    color: #98A2B3;
  }
  #_builder-form .multiselect__tag-icon:hover {

    color: #98A2B3;
    opacity: 0.8;
  }
  #_builder-form .multiselect__tag-icon:hover:after {

    color: #98A2B3;
  }

  /* Single select dropdown styles */
  #_builder-form select option:hover {
    background-color: #${fieldStyle.primaryColor};
    color: #000000;
  }

  /* Custom dropdown components */
  #_builder-form .dropdown-option:hover {
    background-color: #${fieldStyle.primaryColor};
    color: #000000;
  }

  /* Button styles when mapPrimaryColorToButtonColor is enabled - only for submit buttons */
  ${
    fieldStyle?.mapPrimaryColorToButtonColor
      ? `
  #_builder-form button[type=submit],
  #_builder-form .btn[type=submit],
  #_builder-form .form-builder--item button[type=submit],
  #_builder-form .form-builder--item .btn[type=submit],
  #_builder-form input[type=submit] {
    background-color: #${fieldStyle.primaryColor} !important;
    border-color: #${fieldStyle.primaryColor} !important;
  }
  #_builder-form button[type=submit]:hover,
  #_builder-form .btn[type=submit]:hover,
  #_builder-form .form-builder--item button[type=submit]:hover,
  #_builder-form .form-builder--item .btn[type=submit]:hover,
  #_builder-form input[type=submit]:hover {
    background-color: #${fieldStyle.primaryColor} !important;
    border-color: #${fieldStyle.primaryColor} !important;
    opacity: 0.9;
  }
  #_builder-form button[type=submit]:focus,
  #_builder-form .btn[type=submit]:focus,
  #_builder-form .form-builder--item button[type=submit]:focus,
  #_builder-form .form-builder--item .btn[type=submit]:focus,
  #_builder-form input[type=submit]:focus {
    background-color: #${fieldStyle.primaryColor} !important;
    border-color: #${fieldStyle.primaryColor} !important;
    outline: none;
  }
  #_builder-form button[type=submit]:active,
  #_builder-form .btn[type=submit]:active,
  #_builder-form .form-builder--item button[type=submit]:active,
  #_builder-form .form-builder--item .btn[type=submit]:active,
  #_builder-form input[type=submit]:active {
    background-color: #${fieldStyle.primaryColor} !important;
    border-color: #${fieldStyle.primaryColor} !important;
    opacity: 0.8;
  }`
      : ""
  }`;
  };

  return `
  #_builder-form .form-builder--item input[type=text][class=form-control],#_builder-form .form-builder--item .date-picker-custom-style,#_builder-form .form-builder--item input[type=number]{
    background-color: #${fieldStyle.bgColor} !important;
    color: #${fieldStyle.fontColor} !important;
    ${isLineEnabled ? "border-bottom" : "border"}: ${fieldStyle.border.border}px ${
    fieldStyle.border.type
  } #${fieldStyle.border.color} !important;
    border-radius: ${isLineEnabled ? 0 : fieldStyle.border.radius}px !important;
    padding: ${fieldStyle.padding.top}px ${fieldStyle.padding.right}px ${
    fieldStyle.padding.bottom
  }px ${fieldStyle.padding.left}px !important;
    box-shadow: ${fieldStyle.shadow.horizontal}px ${fieldStyle.shadow.vertical}px ${
    fieldStyle.shadow.blur
  }px ${fieldStyle.shadow.spread}px #${fieldStyle.shadow.color};
    font-family: '${fieldStyle.placeholderFontFamily}';
    font-size: ${fieldStyle.placeholderFontSize}px;
    font-weight: ${fieldStyle.placeholderFontWeight};
    background-clip: inherit !important;
  }
  #_builder-form textarea {
    background-color: #${fieldStyle.bgColor} !important;
    color: #${fieldStyle.fontColor} !important;
    ${isLineEnabled ? "border-bottom" : "border"}: ${fieldStyle.border.border}px ${
    fieldStyle.border.type
  } #${fieldStyle.border.color} !important;
    border-radius: ${isLineEnabled ? 0 : fieldStyle.border.radius}px !important;
    padding: ${fieldStyle.padding.top}px ${fieldStyle.padding.right}px ${
    fieldStyle.padding.bottom
  }px ${fieldStyle.padding.left}px !important;
    box-shadow: ${fieldStyle.shadow.horizontal}px ${fieldStyle.shadow.vertical}px ${
    fieldStyle.shadow.blur
  }px ${fieldStyle.shadow.spread}px #${fieldStyle.shadow.color} !important;
    font-family: '${fieldStyle.placeholderFontFamily}';
    font-size: ${fieldStyle.placeholderFontSize}px;
    font-weight: ${fieldStyle.placeholderFontWeight};
    background-clip: inherit !important;
  }
  #_builder-form input[type=tel],#_builder-form input[type=email],#_builder-form .multiselect .multiselect__tags{
    background-color: #${fieldStyle.bgColor} !important;
    color: #${fieldStyle.fontColor} !important;
    border: ${
      isLineEnabled
        ? "none;"
        : `${fieldStyle.border.border}px ${fieldStyle.border.type} #${fieldStyle.border.color} !important;`
    }
    ${isLineEnabled ? "border-bottom" : "border"}: ${fieldStyle.border.border}px ${
    fieldStyle.border.type
  } #${fieldStyle.border.color} !important;
    border-radius: ${isLineEnabled ? 0 : fieldStyle.border.radius}px !important;
    padding: ${fieldStyle.padding.top}px ${fieldStyle.padding.right}px ${
    fieldStyle.padding.bottom
  }px ${fieldStyle.padding.left}px !important;
    box-shadow: ${fieldStyle.shadow.horizontal}px ${fieldStyle.shadow.vertical}px ${
    fieldStyle.shadow.blur
  }px ${fieldStyle.shadow.spread}px #${fieldStyle.shadow.color};
    font-family: '${fieldStyle.placeholderFontFamily}';
    font-size: ${fieldStyle.placeholderFontSize}px;
    font-weight: ${fieldStyle.placeholderFontWeight};
    background-clip: inherit !important;
  }
  #_builder-form .multi_select_form {
    border-radius: ${isLineEnabled ? 0 : fieldStyle.border.radius}px !important;
  }
  #_builder-form .iti--allow-dropdown input, .iti--allow-dropdown input[type=tel]{
    padding-left: ${
      parseFloat(isLineEnabled ? fieldStyle.padding.left + 20 : fieldStyle.padding.left) + 30
    }px !important;
  }
  #_builder-form .countryphone {
    height: inherit;
  }


  #_builder-form .form-builder--item .date-picker-custom-style input[type=text],  #_builder-form .form-builder--item .multiselect .multiselect__placeholder {
    padding:0;
    background-color: #${fieldStyle.bgColor};
    color: #${fieldStyle.fontColor};
    font-size: ${fieldStyle.placeholderFontSize}px;
  }
  #_builder-form .form-builder--item .multiselect .multiselect__input{
    background-color: #${fieldStyle.bgColor} !important;
  }
  #_builder-form .form-builder--item .multiselect .multiselect__select{
    background: transparent;
    z-index:10;
  }
  #_builder-form .form-builder--item .multiselect ,.multiselect__single{
    padding:0 !important;
    margin:0 !important;
    min-height: 24px;
    color:  #${fieldStyle.fontColor} !important;
    background-color: #${fieldStyle.bgColor} !important;
    font-family: '${fieldStyle.placeholderFontFamily}';
    font-size: ${fieldStyle.placeholderFontSize}px;
    font-weight: ${fieldStyle.placeholderFontWeight};
  }
  #_builder-form .form-builder--item  .multiselect__placeholder {
    padding:0 !important;
    margin:0 !important;
    min-height: 24px;
    color: #${placeholderColor} !important;
    background-color: #${fieldStyle.bgColor} !important;
    font-family: '${placeholderFontFamily}';
    font-size: ${placeholderFontSize}px;
    font-weight: ${placeholderFontWeight};
  }
  #_builder-form .field-container{
    width:100%;
    max-width: ${fieldStyle.width}px;
  }
  #_builder-form ::-webkit-input-placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #${placeholderColor};
    font-family: '${placeholderFontFamily}';
    font-size: ${placeholderFontSize}px;
    font-weight: ${placeholderFontWeight};
    opacity: 1; /* Firefox */
  }
  #_builder-form ::placeholder, .signature-placeholder {
    color: #${placeholderColor} !important;
    font-family: '${placeholderFontFamily}';
    font-size: ${placeholderFontSize}px;
    font-weight: ${placeholderFontWeight};
  }

  #_builder-form .input-icon {
    color: #${placeholderColor};
  }
    
  #_builder-form :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #${placeholderColor} !important;
    font-family: '${placeholderFontFamily}';
    font-size: ${placeholderFontSize}px;
    font-weight: ${placeholderFontWeight};
  }
  #_builder-form ::-ms-input-placeholder { /* Microsoft Edge */
    color: #${placeholderColor} !important;
    font-family: '${placeholderFontFamily}';
    font-size: ${placeholderFontSize}px;
    font-weight: ${placeholderFontWeight};
  }

  #_builder-form label{
    color: #${labelColor};
    font-family: '${labelFontFamily}';
    font-size: ${labelFontSize}px;
    font-weight: ${labelFontWeight};
  }
  #_builder-form label * {
    color: #${labelColor};
    font-family: '${labelFontFamily}';
  }
  #_builder-form .text-element * {
    color: inherit;
    font-family: '${labelFontFamily}';
  }
  #_builder-form .short-label{
    color: #${shortLabelColor};
    font-family: '${shortLabelFontFamily}';
    font-size: ${shortLabelFontSize}px;
    font-weight: ${shortLabelFontWeight};
    -webkit-font-smoothing: auto;
  }
  #_builder-form .form-builder--item .payment-suggestion-tag-container {
    background-color: #${fieldStyle.bgColor};
    color: #${fieldStyle.fontColor} !important;
    font-family: '${fieldStyle.placeholderFontFamily}';
    font-size: ${fieldStyle.placeholderFontSize}px;
    font-weight: ${fieldStyle.placeholderFontWeight};
      box-shadow: ${fieldStyle.shadow.horizontal}px ${fieldStyle.shadow.vertical}px ${
    fieldStyle.shadow.blur
  }px ${fieldStyle.shadow.spread}px #${fieldStyle.shadow.color};
  }
  #_builder-form .product-summary-amount-large, #order-confirmation .product-summary-amount-large {
    color: #${labelColor};
    font-size: ${parseFloat(labelFontSize) + 4}px;
    font-weight: ${parseFloat(labelFontWeight) + 200};
    font-family: ${labelFontFamily};
    line-height: 1.5rem;
  }
  #_builder-form .product-summary-amount-normal, #order-confirmation .product-summary-amount-normal {
    color: #${labelColor};
    font-size: ${parseFloat(labelFontSize)}px;
    font-weight: ${parseFloat(labelFontWeight) + 100};
    font-family: ${labelFontFamily};
    line-height: 1.5rem;
  }
  #_builder-form .product-summary-label-bold, #order-confirmation .product-summary-label-bold{
    color: #${labelColor};
    font-size: ${parseFloat(labelFontSize)}px;
    font-weight: ${parseFloat(labelFontWeight) + 200};
    font-family: ${labelFontFamily};
    line-height: 1.5rem;
  }
  #_builder-form .crossed-amount {
    color: #${labelColor};
    font-size: ${parseFloat(labelFontSize) + 2}px;
    font-weight: ${parseFloat(labelFontWeight) + 100};
    font-family: ${labelFontFamily};
    line-height: 1.5rem;
  }
  #_builder-form .product-summary-label-large, #order-confirmation .product-summary-label-large{
    color: #${labelColor};
    font-size: ${parseFloat(labelFontSize) + 2}px;
    font-weight: ${parseFloat(labelFontWeight) + 100};
    font-family: ${labelFontFamily};
    line-height: 1.575rem;
  }
  #_builder-form .product-summary-label-normal, #order-confirmation .product-summary-label-normal{
    color: #${labelColor};
    font-size: ${parseFloat(labelFontSize)}px;
    font-weight: ${parseFloat(labelFontWeight)};
    font-family: ${labelFontFamily};
    line-height: 1.575rem;
  }
  #_builder-form .product-summary-label-small, #order-confirmation .product-summary-label-small{
    color: #${labelColor};
    font-size: ${parseFloat(labelFontSize) - 2}px;
    font-weight: ${parseFloat(labelFontWeight)};
    font-family: ${labelFontFamily};
    line-height: 1.575rem;
  }
  #_builder-form .variant-tag {
    color: #${labelColor};
    font-size: ${parseFloat(labelFontSize) - 1}px;
    font-weight: ${parseFloat(labelFontWeight)};
    font-family: ${labelFontFamily};
    line-height: 1.5rem;
  }
  #_builder-form .selected-tag {
    background-color: #${fieldStyle?.activeTagBgColor} !important;
  }
  #_builder-form .payment-tag, #_builder-form .quantity-container-counter {
    box-shadow: ${fieldStyle.shadow.horizontal}px ${fieldStyle.shadow.vertical}px ${
    fieldStyle.shadow.blur
  }px ${fieldStyle.shadow.spread}px #${fieldStyle.shadow.color};
    background-color : #${fieldStyle.bgColor};
  }
  #_builder-form .quantity-container-counter  {
    padding-top: ${fieldStyle.padding.top - 2}px !important;
    padding-bottom:  ${fieldStyle.padding.bottom - 2}px !important;
  }
  #_builder-form .quantity-text {
    font-size: ${fieldStyle.placeholderFontSize}px !important;
  }
  .bubble-label, .bubble-checkbox-label {
    background-color: #${fieldStyle.bgColor} !important;
    color: #${placeholderColor} !important;
    font-family: '${placeholderFontFamily}' !important;
    font-size: ${placeholderFontSize}px !important;
    font-weight: ${placeholderFontWeight} !important;
  }
  .bubble-container, .bubble-checkbox-container {
    border: ${fieldStyle.border.border}px ${fieldStyle.border.type} #${
    fieldStyle.border.color
  } !important;
    border-radius: 12px !important;
    /* Small horizontal gap between bubbles */
    margin-left: 2px !important;
    margin-right: 2px !important;
    padding: ${fieldStyle.padding.top}px ${fieldStyle.padding.right}px ${
    fieldStyle.padding.bottom
  }px ${fieldStyle.padding.left}px !important;
    box-shadow: ${fieldStyle.shadow.horizontal}px ${fieldStyle.shadow.vertical}px ${
    fieldStyle.shadow.blur
  }px ${fieldStyle.shadow.spread}px #${fieldStyle.shadow.color};
    font-family: '${labelFontFamily}';
    font-size: ${labelFontSize}px;
    font-weight: ${labelFontWeight};
    background-clip: inherit !important;
  }
  .vdpHeadCellContent {
    word-wrap: normal;
    }

  ${getHoverFocusStyles()}
  `;
};

export const defaultButtonStyle = {
  bgColor: "18BD5BFF",
  color: "FFFFFF",
  subTextColor: "FFFFFF",
  border: 0,
  radius: 0,
  borderColor: "000000",
  fontSize: 14,
  subTextFontSize: 14,
  weight: 600,
  subTextWeight: 200,
  borderType: "solid",
  shadow: {
    color: "FFFFFF",
    horizontal: 0,
    vertical: 0,
    blur: 0,
    spread: 0,
  },
  padding: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  fontFamily: "Roboto",
  subTextFontFamily: "Roboto",
  submitSubText: "",
  align: "center",
};

export const defaultPaymentSettings = {
  liveModeOn: false,
  suggestionOn: true,
  recurringDonation: {
    isRecurringDonationEnabled: false,
    recurringDonationFrequency: ["once", "day", "week", "month", "year"],
  },
  products: [],
  bumpProducts: [],
  layout: 1,
  paymentType: "product",
  amountPlaceHolder: "",
  suggestedAmount: [4.99, 5.99, 9.99],
  enableOtherAmount: true,
  required: true,
  currency: { code: "USD", symbol: "$" },
  showInfoAboutPayment: false,
  tagActiveBGColor: "009ef426",
  footer: {
    message: t("common.payment.securePayments"),
    hidden: false,
  },
  coupon: {
    enableCoupon: false,
    couponAlignment: "right",
  },
  selectionType: "checkbox",
  bumpSettings: { ...getBumpSettings },
};

export const defaultResultTemplate = {
  layout: {
    width: 600,
    backgroundColor: "FFFFFF",
    backgroundImage: "",
  },
  tiers: [
    {
      id: "K9mP2x",
      label: "Low",
      color: "#F04438",
      fromPercent: 0,
      toPercent: 39,
    },
    {
      id: "A7bN4q",
      label: "Medium",
      color: "#F79009",
      fromPercent: 40,
      toPercent: 70,
    },
    {
      id: "Z3kL8w",
      label: "High",
      color: "#12B76A",
      fromPercent: 71,
      toPercent: 100,
    },
  ],
  headerSettings: {
    enableBusinessName: true,
    headerLayout: "default",
    headerImage: "",
    imageWidth: "32",
    imageHeight: "32",
    marginPadding: {
      margin: {
        top: "auto",
        bottom: "auto",
        left: "auto",
        right: "auto",
      },
      padding: {
        top: "16",
        bottom: "16",
        left: "16",
        right: "16",
      },
    },
    headingHtml: '<p><span style="font-size: 32px">Default Quiz</span></p>',
    backgroundColor: "FFFFFF",
  },
  overallScoreSettings: {
    dynamicContent: true,
    content: {
      Low: "Thank you for taking the time to complete this quiz.",
      Medium: "Thank you for taking the time to complete this quiz.",
      High: "Thank you for taking the time to complete this quiz.",
    },
    overallScoreTitle: {
      Low: "Overall score",
      Medium: "Overall score",
      High: "Overall score",
    },
    staticContent: {
      content: "Thank you for taking the time to complete this quiz.",
      overallScoreTitle: "Overall score",
    },
    scorePosition: "right",
    showOverallScore: true,
    overallScoreFormat: "percentage",
    showTiers: true,
    marginPadding: {
      margin: {
        top: "auto",
        bottom: "auto",
        left: "auto",
        right: "auto",
      },
      padding: {
        top: "16",
        bottom: "16",
        left: "16",
        right: "16",
      },
    },
    backgroundColor: "FFFFFF",
  },
  categoryScoreSettings: {
    dynamicContent: true,
    heading: {
      Low: "Thank you for taking the time to complete this quiz.",
      Medium: "Thank you for taking the time to complete this quiz.",
      High: "Thank you for taking the time to complete this quiz.",
    },
    staticContent: {
      heading: "Thank you for taking the time to complete this quiz.",
    },
    orderCategories: "highestOrder",
    showScore: true,
    scoreFormat: "percentage",
    marginPadding: {
      margin: {
        top: "auto",
        bottom: "auto",
        left: "auto",
        right: "auto",
      },
      padding: {
        top: "32",
        bottom: "32",
        left: "24",
        right: "24",
      },
    },
    sectionBackground: "FFFFFF",
    categoryBackground: "FFFFFF",
  },
  ctaSettings: {
    dynamicContent: true,
    category: "overAllScore",
    heading: {},
    buttonText: {},
    buttonLink: {},
    staticContent: {
      heading:
        '<p><strong>Want to talk about your results?</strong></p><p><span style="font-size: 14px; color: rgba(71,84,103,1) !important; color: rgba(71,84,103,1) !important">If you\'d like to learn more about your score and what it means for your business lets jump on a zoom call</span></p>',
      buttonText: "Subscribe",
      buttonLink: "",
    },
    buttonColor: "155EEF",
    buttonTextColor: "FFFFFF",
    marginPadding: {
      margin: {
        top: "auto",
        bottom: "auto",
        left: "auto",
        right: "auto",
      },
      padding: {
        top: "32",
        bottom: "32",
        left: "24",
        right: "24",
      },
    },
    backgroundColor: "FFFFFF",
    categoryBackground: "FFFFFF",
  },
  footerSettings: {
    enableBusinessName: true,
    footerImage: "",
    imageWidth: "32",
    imageHeight: "32",
    showAddSocials: true,
    socialLinks: [
      {
        label: "Google",
        value: "www.google.com",
        id: 0,
      },
    ],
    sticky: true,
    allowRowsToTakeFullWidth: true,
    marginPadding: {
      margin: {
        top: "auto",
        bottom: "auto",
        left: "auto",
        right: "auto",
      },
      padding: {
        top: "16",
        bottom: "16",
        left: "16",
        right: "16",
      },
    },
    backgroundImage: "",
    backgroundColor: "FFFFFF",
    footerHTML: "<p>Default Quiz</p>",
  },
};

export const defaultAddressSettings = {
  autoCompleteEnabled: true,
  required: true,
  children: [],
  label: t("common.address"),
  placeholder: t("common.searchAddress"),
};
